/** Convert a company name to a stable DOM section ID. Used by NarrativeView and PublicProfile for [FOCUS:company] scroll. */
export function companyToSectionId(company: string): string {
	return `work-${company.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}`;
}
